import { SI_SENTRY_TAGS } from "app/pages/sales-intelligence/constants/sentry";
import type { UserActivityData } from "app/pages/sales-intelligence/types/customTrackingParams";
import { createSentryTrackingInterceptor } from "app/pages/sales-intelligence/utils/tracking/sentry";
import { DefaultFetchService } from "app/services/fetchService";

const ENDPOINT = "sales-api/user-activity";
const LAST_ACTIVITY_ENDPOINT = `${ENDPOINT}/last-activity`;

export type LastActivityDto = Readonly<{
    lastActivity: string;
}>;

const sentryTrackingInterceptor = createSentryTrackingInterceptor({
    errorMessage: "Error executing a userActivityService request",
    tags: { solution: SI_SENTRY_TAGS.solution, component: "userActivityService" },
});

const fetchService = DefaultFetchService.getInstance();

const trackedFetch = <T>(...params: Parameters<typeof fetchService.get>): Promise<T> =>
    sentryTrackingInterceptor(() => fetchService.get<T>(...params));

const userActivityService = {
    fetch(): Promise<UserActivityData> {
        return trackedFetch<UserActivityData>(ENDPOINT, undefined, {
            preventAutoCancellation: true,
        });
    },

    fetchLastActivity(): Promise<LastActivityDto> {
        return trackedFetch<LastActivityDto>(LAST_ACTIVITY_ENDPOINT, undefined, {
            preventAutoCancellation: true,
        });
    },
};

export default userActivityService;
